import { logout } from '@/features/auth';
import type { State } from '@/reducers/types';
import { SignupNotificationEmails } from '@/types';
import { createSlice } from '@reduxjs/toolkit';
import {
  addSignupNotificationEmail,
  deleteSignupNotificationEmail,
  getSignupNotificationEmails,
} from './actions';

export interface SignupNotificationEmailsState {
  signupNotificationEmails: SignupNotificationEmails | null;
}

const initialState: SignupNotificationEmailsState = {
  signupNotificationEmails: { emails: [] },
};

export const { name, reducer } = createSlice({
  name: 'signupNotificationEmails',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSignupNotificationEmails.fulfilled, (state, action) => {
        state.signupNotificationEmails = action.payload;
      })
      .addCase(addSignupNotificationEmail.fulfilled, (state, action) => {
        state.signupNotificationEmails = action.payload;
      })
      .addCase(deleteSignupNotificationEmail.fulfilled, (state, action) => {
        state.signupNotificationEmails = action.payload;
      })
      .addCase(logout.fulfilled, () => initialState);
  },
});

export const selectSignupNotificationEmails = (state: State) =>
  state[name].signupNotificationEmails;
